import { AuthInfo } from '@provider/api/typing'
import Cookies from 'universal-cookie'
import localStore from '@service/local-store'
import { createApiClient } from '@util/api'
import { LOCALHOST_NAME, OPTUM_MATCH_HOST_NAME } from '../../../constants'

const auth = createApiClient('/auth/')

const shouldUseOriginDirectly = () => {
  const host = window.location.hostname.toLowerCase()
  return (
    host === LOCALHOST_NAME ||
    host === OPTUM_MATCH_HOST_NAME ||
    host.endsWith('.optummatch.com')
  )
}

const getAuthOriginParam = () =>
  shouldUseOriginDirectly()
    ? window.location.origin
    : window.location.origin + '/providers/login'

const cookies = new Cookies()

export const ssoRedirectUrl = (code_challenge: string) =>
  // NOTE: We cannot force-send a UI-domain cookie to a different domain (API_ORIGIN)
  // from the browser. Instead, forward the selected auth type explicitly.
  // Backend must read this param if it needs auth_type during SSO initiation.
  auth.get('login', {
    // maxRedirects: 0,
    params: {
      origin: getAuthOriginParam(),
      code_challenge,
      ...(cookies.get('auth_type') || localStore.get('auth_type')
        ? { auth_type: cookies.get('auth_type') || localStore.get('auth_type') }
        : {}),
    },
  })

export const refreshToken = (refreshToken: string) =>
  auth.get('refresh', { params: { token: refreshToken } })

export const exchangeCodeForTokenAndClaims = (
  code: string,
  code_verifier: string
) =>
  auth.get<AuthInfo>('validate', {
    params: {
      code,
      origin: getAuthOriginParam(),
      code_verifier,
      ...(cookies.get('auth_type') || localStore.get('auth_type')
        ? { auth_type: cookies.get('auth_type') || localStore.get('auth_type') }
        : {}),
    },
  })

export const logout = () =>
  auth.get('logout', { params: { redirect_uri: window.location.origin + '/' } })
